import $ from 'jquery';
import Cache from 'root/cache';
import Util from 'root/module/util';
import View from 'view/base';

export default View.extend({
    status_ids: [],
    categories: [],
    search: '',
    page: '',

    events: {
        'click .tag-status'   : 'onSelectStatus',
        'click .tag-category' : 'onSelectCategory'
    },

    dom_handlers: {
        onSelectStatus: function(e) {
            var status_id = parseInt($(e.currentTarget).data('val'), 10);
            var index     = this.status_ids.indexOf(status_id);

            if (index === -1) {
                this.status_ids.push(status_id);
            } else {
                this.status_ids.splice(index, 1);
            }

            $(e.currentTarget).toggleClass('active', index === -1);

            this.trigger('change:tag', this.status_ids, this.categories);
        },

        onSelectCategory: function(e) {
            var category = $(e.currentTarget).data('val');
            var index    = this.categories.indexOf(category);

            if (index === -1) {
                this.categories.push(category);
            } else {
                this.categories.splice(index, 1);
            }

            $(e.currentTarget).toggleClass('active', index === -1);

            this.trigger('change:tag', this.status_ids, this.categories);
        }
    },

    initialize: function(options) {
        this.status_ids = options.status_ids;
        this.categories = options.categories;
        this.search     = options.search;
        this.page       = options.page;
    },

    setOptions: function(options) {
        if (typeof options.status_ids !== 'undefined') {
            this.status_ids = options.status_ids;
        }

        if (typeof options.categories !== 'undefined') {
            this.categories = options.categories;
        }

        if (typeof options.search !== 'undefined') {
            this.search = options.search;
        }

        return this;
    },

    loadFeedbackCategories: function() {
        this.renderFeedbackCategories();

        Cache.app.request({
            action: 'portal/countFeedback',
            data: {
                search: this.search
            },
            success: (response) => {
                response.forEach((data) => {
                    if (typeof data.status_id !== 'undefined') {
                        this.$el.find('.status-count[data-val="' + data.status_id + '"]').text(data.count);
                    } else if (typeof data.category !== 'undefined') {
                        this.$el.find('.category-count[data-val="' + data.category + '"]').text(data.count);
                    }
                });
            }
        });
    },

    renderFeedbackCategories: function(data) {
        var category_options = '';

        Cache.feedback_category.each(function(option) {
            if (Cache.portal.at(0).get('categories').split(',').indexOf(option.get('name')) === -1) {
                return;
            }

            var is_selected = this.categories.indexOf(option.get('name')) !== -1;

            category_options += '<li class="tag-category' + (is_selected ? ' active' : '') + '" data-val="' + option.escape('name') + '">' +
                                    '<span class="category-count" data-val="' + option.escape('name') + '"></span>' +
                                    '<span class="icon-category"><i class="fas fa-hashtag"></i></span>' +
                                    '<span>' + option.escape('name') + '</span>' +
                                '</li>';
        }, this);

        this.$el.find('.category-list').html(category_options);
    },

    loadAnnouncementCategories: function() {
        Cache.app.request({
            action: 'portal_announcement/count',
            data: {
                search: this.search
            },
            success: (response) => {
                Cache.add('announcement_categories', response, false);
                this.renderAnnouncementCategories();
            }
        });
    },

    renderAnnouncementCategories: function() {
        var category_options = '';

        if (Cache.get('announcement_categories').length) {
            Cache.get('announcement_categories').forEach(function(option) {
                var is_selected = this.categories.indexOf(option.category) !== -1;

                category_options += '<li class="tag-category' + (is_selected ? ' active' : '') + '" data-val="' + Util.htmlEntities(option.category) + '">' +
                                        '<span class="category-count" data-val="' + Util.htmlEntities(option.category) + '">' + option.count + '</span>' +
                                        '<span class="icon-category"><i class="fas fa-hashtag"></i></span>' +
                                        '<span>' + Util.htmlEntities(option.category) + '</span>' +
                                    '</li>';
            }, this);
        } else {
            category_options += '<li class="disabled">No tags created</li>';
        }

        this.$el.find('.category-list').html(category_options);
    },

    onRender: function() {
        if (this.page === 'announcement') {
            this.loadAnnouncementCategories();
        } else {
            this.loadFeedbackCategories();
        }
    },

    render: function() {
        var content = '';

        var status_options = '';

        var title = this.page === 'announcement' ? 'Tags' : 'Categories';

        if (this.status_ids) {
            Cache.portal_status.each(function(option) {
                var is_selected = this.status_ids.indexOf(option.id) !== -1;

                status_options += '<li class="tag-status' + (is_selected ? ' active' : '') + '" data-val="' + option.id + '">' +
                                        '<span class="status-count" data-val="' + option.id + '"></span>' +
                                        '<span class="icon-status" style="background-color:' + option.get('colour') + ';box-shadow:0 0 0 3px ' + Util.hexToRgba(option.get('colour'), 0.4) + ';"></span>' +
                                        '<span>' + option.escape('status_name') + '</span>' +
                                    '</li>';
            }, this);


            content += '<div class="section">' +
                            '<div class="title">Status:</div>' +
                            '<ul>' + status_options + '</ul>' +
                        '</div>';
        }

        content += '<div class="section">' +
                        '<div class="title">' + title + ':</div>' +
                        '<ul class="category-list"></ul>' +
                    '</div>';

        this.$el.html(content);

        this.onRender();

        return this;
    }
});